import {authRoles} from 'app/auth';
import React from 'react';

export const UsersAppConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth    : authRoles.admin,
    routes  : [
        {
            path     : '/users',
            component: React.lazy(() => import('./UsersApp'))
        }
    ]
};
